import { useSelector, useDispatch } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import Footer from '../components/Footer';
import { logout } from '../redux/userSlice';
import React, { useEffect } from 'react';

const PrivateRoute = () => {
  const location = useLocation();
  const t = useTranslation();
  const dispatch = useDispatch();
  const { user, sessionChecked } = useSelector((state) => state.user);

  useEffect(() => {
    if (sessionChecked && user && user.status !== 1) {
      dispatch(logout());
    }
  }, [user, sessionChecked, dispatch]);

  // 1. Wait for App.js to finish the initial session check (CurrentUser)
  if (!sessionChecked) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <div className="spinner"></div>
        <p>{t('validating_session')}...</p>
      </div>
    );
  }

  // 2. Once checked, if no user exists or user is not active, redirect to login
  if (!user || user.status !== 1) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 3. Otherwise, render the protected content wrapped in a sticky footer layout
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 12px)',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          flex: '1 0 auto',
        }}
      >
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default PrivateRoute;
